import { render } from "./InputPassword.vue?vue&type=template&id=7daa2b1a"
import script from "./InputPassword.vue?vue&type=script&lang=js"
export * from "./InputPassword.vue?vue&type=script&lang=js"
script.render = render

export default script